module.exports = ".dropdown_button_class{\n  white-space: inherit;\n  width: 40%;\n}\n\n.dropdown_li_element{\n  cursor: pointer;\n}\n\n.dropdown_a_tag{\n  color: black;\n}\n\n.dropdown-menu-ul-tag{\n  min-width: 80px;\n}\n\n.dropdown-main-class{\n  max-height: 25vh;\n}\n\n.mat-dialog-content{\n  max-height: 25vh;\n}\n\n.mat-dialog-content{\n  height: 100px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/calendar-type/calendar-type-dialog/calendar-type-dialog.component.css
// module id = ./src/app/questions-type/calendar-type/calendar-type-dialog/calendar-type-dialog.component.css
// module chunks = main